module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c2Hnk"))).then(() => parcelRequire('5erN3'));